import { createSlice } from '@reduxjs/toolkit';
import { addNewVehicleCost, editVehicleCost, getAllVehicleCost } from './vehicleCostService';

const initialState = {
  allVehicleCost: {
    isVehicleCostLoading: null,
    isVehicleCostSuccess: null,
    vehicleCostMessage: null,
    pageCount: 0,
    vehicleCost: [],
  },
  newVehicleCost: {
    isVehicleCostCreating: null,
    isVehicleCostCreated: null,
    vehicleCostCreationMsg: null,
  },

  editedVehicleCost: {
    isEditingVehicleCost: null,
    isVehicleCostEdited: null,
    vehicleCostEditedMsg: null
  }
};

const vehicleCostSlice = createSlice({
  name: 'vehicleCost',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // PENDING
    builder
      .addCase(getAllVehicleCost.pending, (state) => {
        state.allVehicleCost = {
          ...initialState.allVehicleCost, // Reset to initial state
          isVehicleCostLoading: true,
          vehicleCostMessage: 'Loading',
        };
      })

      // REJECTED
      .addCase(getAllVehicleCost.rejected, (state, action) => {
        state.allVehicleCost = {
          ...initialState.allVehicleCost,
          isVehicleCostLoading: false,
          isVehicleCostSuccess: false,
          vehicleCostMessage: action.payload || 'Error occurred while fetching vehicleCost',
        };
      })

      // FULFILLED
      .addCase(getAllVehicleCost.fulfilled, (state, action) => {
        state.allVehicleCost = {
          ...initialState.allVehicleCost,
          isVehicleCostLoading: false,
          isVehicleCostSuccess: true,
          pageCount: action.payload.pageCount || 0,
          vehicleCost: action.payload.data || [],
        };
      });

    //VehicleCost creating
    builder
      .addCase(addNewVehicleCost.pending, (state) => {
        state.newVehicleCost = {
          ...initialState.newVehicleCost, // Reset to initial state
          isVehicleCostCreating: true,
          vehicleCostCreationMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(addNewVehicleCost.rejected, (state, action) => {
        state.newVehicleCost = {
          ...initialState.newVehicleCost,
          isVehicleCostCreating: false,
          isVehicleCostCreated: false,
          vehicleCostCreationMsg: action.payload || 'Error occurred while creating the vehicleCost.',
        };
      })

      // FULFILLED
      .addCase(addNewVehicleCost.fulfilled, (state, action) => {
        state.newVehicleCost = {
          ...initialState.newVehicleCost,
          isVehicleCostCreating: false,
          isVehicleCostCreated: true,
          vehicleCostCreationMsg: action.payload || 'Successfully created the vehicleCost.',
        };
      });

    //VehicleCost editing
    builder
      .addCase(editVehicleCost.pending, (state) => {
        state.editedVehicleCost = {
          ...initialState.editedVehicleCost, // Reset to initial state
          isEditingVehicleCost: true,
          vehicleCostEditedMsg: 'Loading',
        };
      })

      // REJECTED
      .addCase(editVehicleCost.rejected, (state, action) => {
        state.editedVehicleCost = {
          ...initialState.editedVehicleCost, // Reset to initial state
          isEditingVehicleCost: false,
          isVehicleCostEdited: false,
          vehicleCostEditedMsg: action.payload || 'Error occurred while editing the vehicleCost.',
        };
      })

      // FULFILLED
      .addCase(editVehicleCost.fulfilled, (state, action) => {
        state.editedVehicleCost = {
          ...initialState.editedVehicleCost, // Reset to initial state
          isEditingVehicleCost: false,
          isVehicleCostEdited: true,
          vehicleCostEditedMsg: action.payload || 'Successfully edited the vehicleCost.',
        };
      });
  },
});

export default vehicleCostSlice.reducer;
